import {Dispatch, SetStateAction} from "react";
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";

interface RowsPerPageProps {
    rowsPerPage : number
    setRowsPerPage?: Dispatch<SetStateAction<number>>
    setCurrentPage?: Dispatch<SetStateAction<number>>
}

export const RowsPerPage = ({rowsPerPage, setRowsPerPage, setCurrentPage} : RowsPerPageProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation('components');

    const onChangeRowsPerPage = (newRowsPerPage : number) =>
    {
        if (setRowsPerPage !== undefined) {
            setRowsPerPage(newRowsPerPage);
        }

        // reset the current page because the old page might not exist
        if (setCurrentPage !== undefined) {
            setCurrentPage(1);
        }
    }


    return (
        <Form.Select size="sm" className="ms-3" aria-label="Number of rows per page" value={rowsPerPage}
                     onChange={(e) => onChangeRowsPerPage(Number(e.target.value))}>
            <option>{t("pager.rows-per-page")}</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="40">40</option>
            <option value="80">80</option>
        </Form.Select>
    )
}
